import Vue from 'vue'
import TwoFactor from './two-factor.vue'

const TwoFactorConstructor = Vue.extend(TwoFactor)

function showTwoFactor (options = {}, params = {}) {
    return new Promise((resolve, reject) => {
        const { i18n } = options
        const instance = new TwoFactorConstructor({
            el: document.createElement('div'),
            i18n, // 注入 i18n 实例
            propsData: options
        })

        document.body.appendChild(instance.$el)

        let isRemoved = false

        instance.$on('verify-success', (data) => {
            if (!isRemoved) {
                resolve(data)
                removeInstance()
            }
        })

        instance.$on('verify-cancel', () => {
            if (!isRemoved) {
                reject(new Error('VERIFICATION_CANCELLED'))
                removeInstance()
            }
        })

        instance.showDialog(params)

        function removeInstance () {
            if (isRemoved) return
            isRemoved = true
            instance.$destroy()
            if (document.body.contains(instance.$el)) {
                document.body.removeChild(instance.$el)
            }
        }
    })
}

export default {
    install (Vue, options = {}) {
        Vue.prototype.$showTwoFactor = function (params) {
            return showTwoFactor({ ...options, i18n: this.$i18n }, params)
        }
    }
}
